/* eslint-disable max-lines */
// 9fbef606107a605d69c0edbcd8029e5d
/*
  @Important
  If any changes specific to add to bag from collection or outfit container then make sure that the same changes should be done in the both outfitDetail.container and BundleProduct.container file. The Outfit and collection designs are same so we are using outfit view on the both container.
*/

import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import isEqual from 'lodash/isEqual';
import logger from '@tcp/core/src/utils/loggerInstance';
import { getAlternateBrandName } from '@tcp/core/src/components/features/browse/SearchDetail/container/SearchDetail.selectors';
import { setSlpLoadingState } from '@tcp/core/src/components/features/browse/SearchDetail/container/SearchDetail.actions';
import {
  getBrandNameFromHref,
  extractPID,
  isServer,
  getAPIConfig,
} from '@tcp/core/src/utils/utils';
import {
  getServerTimeFromState,
  getPromotionsData,
  getPLCCDiscountValue,
} from '@tcp/core/src/components/common/organisms/Promotions/container/Promotions.selectors';
import { toastMessageInfo } from '@tcp/core/src/components/common/atoms/Toast/container/Toast.actions';
import { isCanada, isClient, parseBoolean } from '@tcp/core/src/utils';
import { setClickAnalyticsData, trackClick } from '@tcp/core/src/analytics/actions';
import { hideProductOriginalPrice } from '@tcp/core/src/components/features/browse/ProductListing/molecules/ProductList/views/ProductGridItem.util';
import EmptyPDP from '@tcp/core/src/components/features/account/Orders/molecules/EmptyPDP';
import {
  setQuickViewProductImage,
  setItemDataForQuickView,
  openQuickViewWithValues,
} from '@tcp/core/src/components/common/organisms/QuickViewModal/container/QuickViewModal.actions';
import {
  getModalState,
  getUniqueId,
} from '@tcp/core/src/components/common/organisms/QuickViewModal/container/QuickViewModal.selectors';
import { getAddToCollectionList } from '@tcp/core/src/components/features/browse/DesignYourBag/container/DesignYourBag.selector';
import { toggleApplyNowModal } from '@tcp/core/src/components/common/molecules/ApplyNowPLCCModal/container/ApplyNowModal.actions';
import {
  resetDesignYourBagData,
  removeProductFromCollections,
  increaseQuantityInCollections,
  decreaseQuantityInCollections,
} from '@tcp/core/src/components/features/browse/DesignYourBag/container/DesignYourBag.actions';
import {
  getProductDetails,
  clearBundleState,
  getInYourBagProductCount,
  setIsBundle,
  carryForwardImgUrl,
} from './BundleProduct.actions';
import {
  getOutfitDetails,
  resetOutfitDetails,
  clearOutfitDetails,
  initActions,
  setSelectedOutfitProductList,
} from '../../OutfitDetails/container/OutfitDetails.actions';

import BundleProduct from '../views';
import BundleProductNewDesign from '../views/BundleProductNewDesign.view';
import {
  getCurrentProduct,
  getShortDescription,
  getGeneralProductId,
  getDescription,
  getCurrentCurrency,
  getCurrencyAttributes,
  getAlternateSizes,
  getCurrentBundle,
  getAddedToBagErrorCatId,
  getBreadCrumbs,
  prodDetails,
  getLoadingState,
  getOnModelImageAbTestBundlePdp,
  getPageUrl,
  getRatingsProductId,
  getSlpData,
  getInYourBagProducts,
  getCarryForwardImgUrl,
  getDepartmentBundleProducts,
} from './BundleProduct.selectors';
import {
  getIsOutfitAddedCTAEnabled,
  getShowAddedToBagCTA,
  getSelectedProductList,
  getOnModelImageAbTestOutfitPdp,
} from '../../OutfitDetails/container/OutfitDetails.selectors';
import getAddedToBagFormValues from '../../../../../reduxStore/selectors/form.selectors';
import { OUTFIT_LISTING_FORM } from '../../../../../constants/reducer.constants';
import { getCartItemInfo } from '../../../CnC/AddedToBag/util/utility';
import {
  addToCartEcom,
  addToCartEcomNewDesign,
  clearAddToBagErrorState,
  clearAddToCartMultipleItemErrorState,
  addMultipleItemsToCartEcom,
  addMultipleItemsToCartEcomNew,
  addToBagPayloadTotalCount,
  setUnavailableProductIds,
} from '../../../CnC/AddedToBag/container/AddedToBag.actions';
import {
  getAddedToBagError,
  getMultipleItemsAddedToBagError,
  getATBUnavailableProducts,
} from '../../../CnC/AddedToBag/container/AddedToBag.selectors';
import { getIsPickupModalOpen } from '../../../../common/organisms/PickupStoreModal/container/PickUpStoreModal.selectors';
import {
  addItemsToWishlist,
  removeAddToFavoriteErrorState,
  getUserFavt,
  setLastDeletedItemIdAction,
  showToastModal,
} from '../../Favorites/container/Favorites.actions';
import {
  isPlccUser,
  getUserLoggedInState,
  isRememberedUser,
} from '../../../account/User/container/User.selectors';
import {
  fetchAddToFavoriteErrorMsg,
  wishListFromState,
  fetchErrorMessages,
  getToastModalState,
  getDefaultFavItemInProgressFlag,
} from '../../Favorites/container/Favorites.selectors';
import {
  getIsKeepAliveProduct,
  getIsInternationalShipping,
  getIsNewReDesignEnabled,
  getIsSyteEnabled,
  getIsDynamicBadgeEnabled,
  getIsPDPSmoothScrollEnabled,
  getIsHiddenPDPAltImageEnabled,
  getIsShowPriceRange,
  getABTestIsShowPriceRange,
  getIsPDPInventoryCheckEnabled,
  getIsHideOriginalPriceAndMarchantTagEnabled,
  getBundleOutfitInfluencerHandleAbTest,
  getBundlePageRedesign,
  getInfluencerPicksEnabled,
  getIsNewSwatchURLEnabled,
  getCurrentCurrencySymbol,
  getIsBuyMorePromoEnabled,
  getIsBundleNewDesignEnabled,
  getIsCombinedKitEnabled,
  getCombinedKits,
  getIsNewDesignToggleOptionsEnabled,
  getDefaultView,
  getIsPJPlannerExperienceEnabled,
  getIsCollectionsZoomEnabled,
  getIsPinchZoomPDPImageEnabled,
  getPlccOfferPercentage,
  getIsUpdatedPromotionsDisplayEnabled,
  getIsPJPlannerStickyMiniBagEnabled,
  getIsSLPNewTileImplementationEnabled,
  getIsSplittingExtendedSizesEnabled,
  getIsDisableDynamicBadgeFlagAbtest,
} from '../../../../../reduxStore/selectors/session.selectors';
import BundleProductItemsSkeleton from '../molecules/BundleProductItemsSkeleton';
import {
  getPDPTopPromos,
  getPlpProductData,
  getSlpProductData,
  getProductInfoFromProductListingData,
} from '../../ProductDetail/container/ProductDetail.selectors';
import { imageData } from '../../OutfitDetails/config';
import {
  getImagesToDisplay,
  getMapSliceForColorProductId,
} from '../../ProductListing/molecules/ProductList/utils/productsCommonUtils';
import { sendPageViewEvent } from '../utils/BundleProduct.analytics';
import {
  getAPIConfigForAdobe,
  getSessionDataForAdobe,
  getUserState,
} from '../../../../../adobeAnalytics/adobe.selectors';
// import BAGPAGE_SELECTORS from '../../../CnC/BagPage/container/BagPage.selectors';

export class ProductBundleContainer extends React.PureComponent {
  selectedColorProductId;

  pathname;

  static getInitialProps = async ({ req, store, props, res }, { setResStatusNotFound } = {}) => {
    let bidGlobal;
    let apiConfigGlobal;
    let newAsPath;
    if (isServer()) {
      const {
        params: { bid = '' },
      } = req;
      const {
        locals: { apiConfig },
      } = res;
      bidGlobal = bid;
      apiConfigGlobal = apiConfig;
    } else {
      const {
        router: {
          query: { bid = '' },
          asPath,
        },
      } = props;
      bidGlobal = bid;
      newAsPath = asPath;
      apiConfigGlobal = getAPIConfig();
    }

    const { brandId = '' } = apiConfigGlobal;
    const [productId] = bidGlobal?.split('-')?.slice(-1);
    // fetching bundle pdp data server side
    if (isServer()) {
      const brandName = getBrandNameFromHref(bidGlobal);
      const isValidBundle = await new Promise((resolve) => {
        return store.dispatch(
          getProductDetails({
            productId,
            ignoreCache: true,
            otherBrand: brandName || brandId,
            apiConfig: apiConfigGlobal,
            resolve,
          })
        );
      });
      if (!isValidBundle && setResStatusNotFound) {
        setResStatusNotFound();
        return {};
      }
    } else {
      const { currentProduct, alternateBrand, isPDPInventoryCheckEnabled } = props;
      const brandName =
        getBrandNameFromHref(bidGlobal) || getBrandNameFromHref(newAsPath) || alternateBrand;
      const currentProductsInfo = currentProduct && Object.keys(currentProduct).length > 0;
      const dataAvailable = currentProductsInfo && props.currentBundle;
      await props.getDetails({
        productId,
        ignoreCache: true,
        otherBrand: brandName || brandId,
        apiConfig: apiConfigGlobal,
        dataAvailable,
        isPDPInventoryCheckEnabled,
      });
    }
    return { props: { ...props } };
  };

  constructor(props) {
    super(props);
    const { route } = props;
    this.state = {
      retrievedProductInfo: null,
      imgConfigVal: '',
      isAnalyticsTriggered: false,
    };
    this.selectedColorProductId = route?.params?.selectedColorProductId || '';
  }

  static getDerivedStateFromProps = (props) => {
    const { plpProductData, slpProductData, router, slpData, isSLPNewTileImplementationEnabled } =
      props;
    const [pid] = router?.query?.bid?.split('-')?.slice(-1);
    if (plpProductData?.uniqueId === pid) {
      return {
        retrievedProductInfo: plpProductData,
        imgConfigVal: imageData.imgConfig,
      };
    }
    if (isSLPNewTileImplementationEnabled && slpProductData?.uniqueId === pid) {
      return {
        retrievedProductInfo: slpProductData,
        imgConfigVal: imageData.imgConfig,
      };
    }
    return {
      retrievedProductInfo: slpData
        ? getProductInfoFromProductListingData({
            pid,
            details: slpData,
          })
        : null,
      imgConfigVal: imageData.imgConfig,
    };
  };

  componentDidMount() {
    try {
      const { navigation, getInYourBagData, setIsBundlePage, isBundlePageRedesign } = this.props;
      if (isBundlePageRedesign) {
        setIsBundlePage(true);
        getInYourBagData();
      }
      const { props } = this;
      ProductBundleContainer.getInitialProps({ props });

      if (!navigation) window.scrollTo(0, 100);
    } catch (e) {
      logger.error({
        error: e,
        extraData: {
          component: 'ProductBundleContainer',
          function: 'componentDidMount',
        },
      });
    }
  }

  fireBundleProductAnalytics(prevCurrentBundle) {
    const { isAnalyticsTriggered } = this.state;
    const { currentBundle = {} } = this.props || {};
    if (
      isAnalyticsTriggered === false &&
      currentBundle &&
      Object.keys(currentBundle)?.length &&
      !isEqual(currentBundle, prevCurrentBundle)
    ) {
      const { User, session, APIConfig } = this.props;
      sendPageViewEvent({ products: currentBundle, User, session, APIConfig });
      this.setState({ isAnalyticsTriggered: true });
    }
  }

  componentDidUpdate(prevProps) {
    try {
      const { router } = this.props;
      const { router: prevRouter, currentBundle: prevCurrentBundle } = prevProps;
      const asPath = (router && router.asPath) || null;
      const prevAsPath = (prevRouter && prevRouter.asPath) || null;
      if (prevAsPath && asPath && prevAsPath !== asPath) {
        this.makeApiCall();
      }
      this.fireBundleProductAnalytics(prevCurrentBundle);
    } catch (e) {
      logger.error({
        error: e,
        extraData: {
          component: 'ProductBundleContainer',
          function: 'componentDidUpdate',
        },
      });
    }
  }

  componentWillUnmount() {
    const {
      resetOutFitProductState,
      clearOutFitProductState,
      clearBundleDetails,
      setIsBundlePage,
      isBundlePageRedesign,
    } = this.props;
    resetOutFitProductState();
    clearOutFitProductState();
    clearBundleDetails();
    if (isBundlePageRedesign) {
      setIsBundlePage(false);
    }
  }

  loadProduct = (productId, brand) => {
    this.makeApiCall(productId, true, brand);
  };

  makeApiCall = (newPID, useNewPID = false, brand) => {
    const {
      getDetails,
      router,
      pageUrl,
      navigation,
      alternateBrand,
      route,
      isPDPInventoryCheckEnabled,
    } = this.props;
    const asPath = (router && router.asPath) || null;
    const pID = this.getPID();
    let productId = pID || extractPID(router, navigation, route);
    const { router: { asPath: asPathVal } = {} } = this.props;
    if (useNewPID) {
      productId = newPID;
    }

    const brandName = getBrandNameFromHref(asPathVal) || alternateBrand || brand;
    const apiConfig = getAPIConfig();
    this.pathname =
      typeof window !== 'undefined' ? asPath || window.location.pathname : this.pathname;
    const [url] = this.pathname.split('?');
    if ((pageUrl && url) || !pageUrl) {
      getDetails({
        productId,
        url,
        ignoreCache: true,
        otherBrand: brandName,
        apiConfig,
        isPDPInventoryCheckEnabled,
      });
    }
  };

  getPID = () => {
    if (isClient()) {
      const currentURL = window && window?.location?.pathname;
      const id = currentURL && currentURL.split('-');
      return id && id.length > 1 ? id[id.length - 1] : id;
    }
    return null;
  };

  checkIfFromPLPorSLP = () => {
    const { router } = this.props;
    if (!isServer() && router?.components) {
      const isProductListing =
        Object.prototype.hasOwnProperty.call(router.components, '/ProductListing') ||
        Object.prototype.hasOwnProperty.call(router.components, '/CategoryListingPage');
      const isSearchPage = Object.prototype.hasOwnProperty.call(router.components, '/SearchDetail');
      return isProductListing || isSearchPage;
    }
    return false;
  };

  extractPID = () => {
    const { router, route } = this.props;
    let pid;
    if (route) {
      pid = route.params?.pdpUrl || '';
    } else {
      const [prodId] = (router.query.bid || '').split('&');
      pid = prodId || '';
    }

    const id = pid && pid.split('-');
    return id && id.length > 1 ? id[id.length - 1] : pid;
  };

  handleAddToBag = (addToBagEcom, productInfo, generalProductId, currentState, primaryBrand) => {
    const { isEnabledOutfitAddedCTA, router, alternateBrand } = this.props;
    const asPath = (router && router.asPath) || null;
    const brandName = getBrandNameFromHref(asPath) || alternateBrand;
    const formName = `${OUTFIT_LISTING_FORM}-${generalProductId}`;
    const formValues = getAddedToBagFormValues(currentState, formName);
    let cartItemInfo = getCartItemInfo(productInfo, formValues);
    cartItemInfo = {
      ...cartItemInfo,
      skipAddToBagModal: isEnabledOutfitAddedCTA,
      primaryBrand,
      alternateBrand: brandName,
    };
    addToBagEcom(cartItemInfo);
  };

  handleMultipleAddToBag = (
    addMultipleToBagEcom,
    productList,
    currentState,
    isSBP = false,
    navigation,
    route,
    primaryBrand
  ) => {
    if (productList.length === 1) {
      const { outfitProduct } = productList[0];
      const { generalProductId } = outfitProduct;
      const { addToBagEcom } = this.props;
      this.handleAddToBag(
        addToBagEcom,
        outfitProduct,
        generalProductId,
        currentState,
        primaryBrand
      );
      return;
    }
    const productItemsInfo = productList.map((productInfo) => {
      const { outfitProduct } = productInfo;
      const { generalProductId } = outfitProduct;
      return this.getCartInfo(
        addMultipleToBagEcom,
        outfitProduct,
        generalProductId,
        currentState,
        isSBP,
        primaryBrand
      );
    });
    addMultipleToBagEcom({ productItemsInfo });
  };

  handlePJPlannerMultiItemAddToBag = ({ productList, primaryBrand, callBack }) => {
    const { addMultipleToBagEcom } = this.props;
    if (productList.length === 1) {
      const { product, formValues } = productList[0];
      this.handlePJPlannerSingleItemAddToBag({
        productInfo: product,
        primaryBrand,
        formValues,
        isFromPjPlanner: true,
        callBack,
      });
      return;
    }

    const productItemsInfo = productList.map((productInfo) => {
      const { product, formValues } = productInfo;
      return this.getPJPlannerCartInfo({ productInfo: product, formValues, primaryBrand });
    });

    addMultipleToBagEcom({ productItemsInfo, callBack, isFromPjPlanner: true });
  };

  getPJPlannerCartInfo = ({ productInfo, formValues, primaryBrand }) => {
    const { isEnabledOutfitAddedCTA } = this.props;
    const {
      newPartNumber: multipackProduct,
      partIdDetail: partIdInfo,
      multiPackCount,
      getMultiPackAllColor: getAllMultiPack,
      getNewMultiPackAllColor: getAllNewMultiPack,
      selectedMultipack,
    } = productInfo;
    let cartItemInfo = getCartItemInfo(productInfo, formValues);
    cartItemInfo = {
      ...cartItemInfo,
      skipAddToBagModal: isEnabledOutfitAddedCTA,
      multipackProduct,
      multiPackCount,
      getAllMultiPack,
      getAllNewMultiPack,
      selectedMultipack,
      partIdInfo,
      primaryBrand,
    };
    return cartItemInfo;
  };

  handlePJPlannerSingleItemAddToBag = ({
    productInfo,
    primaryBrand,
    formValues,
    isFromPjPlanner,
    callBack,
  }) => {
    const { router, alternateBrand, isEnabledOutfitAddedCTA, addToBagEcom } = this.props;

    const asPath = (router && router.asPath) || null;
    const brandName = getBrandNameFromHref(asPath) || alternateBrand;

    let cartItemInfo = getCartItemInfo(productInfo, formValues);
    cartItemInfo = {
      ...cartItemInfo,
      skipAddToBagModal: isEnabledOutfitAddedCTA,
      primaryBrand,
      alternateBrand: brandName,
      isFromPjPlanner,
      callBack,
    };
    addToBagEcom(cartItemInfo);
  };

  getCartInfo = (
    addToBagEcom,
    productInfo,
    generalProductId,
    currentState,
    isSBP,
    primaryBrand
  ) => {
    const { isEnabledOutfitAddedCTA } = this.props;
    const {
      newPartNumber: multipackProduct,
      partIdDetail: partIdInfo,
      multiPackCount,
      getMultiPackAllColor: getAllMultiPack,
      getNewMultiPackAllColor: getAllNewMultiPack,
      selectedMultipack,
    } = productInfo;
    // RWD-16438 Fix: Same form name is removed if user go from outfit to PDP and then press back button.
    const formName = `${OUTFIT_LISTING_FORM}-${generalProductId}`;
    const formValues = getAddedToBagFormValues(currentState, formName);
    let cartItemInfo = getCartItemInfo(productInfo, formValues);
    cartItemInfo = {
      ...cartItemInfo,
      skipAddToBagModal: isEnabledOutfitAddedCTA,
      multipackProduct,
      multiPackCount,
      getAllMultiPack,
      getAllNewMultiPack,
      selectedMultipack,
      partIdInfo,
      primaryBrand,
    };
    cartItemInfo.addedFromSBP = isSBP;
    return cartItemInfo;
  };

  getSingleImageObj = (uniqueId) => {
    const imagePath = `${uniqueId?.split('_')[0]}/${uniqueId}`;
    return [
      {
        isShortImage: false,
        isOnModalImage: false,
        iconSizeImageUrl: imagePath,
        listingSizeImageUrl: imagePath,
        regularSizeImageUrl: imagePath,
        bigSizeImageUrl: imagePath,
        superSizeImageUrl: imagePath,
      },
    ];
  };

  getPlpImages = () => {
    const { retrievedProductInfo } = this.state;
    if (retrievedProductInfo) {
      const { colorFitsSizesMap, uniqueId, imagesByColor } = retrievedProductInfo;
      const currentColorEntry = getMapSliceForColorProductId(colorFitsSizesMap, uniqueId) || {};
      let imagesToDisplay = getImagesToDisplay({
        imagesByColor,
        curentColorEntry: currentColorEntry,
        isAbTestActive: false,
        isFullSet: true,
        excludeShortImage: false,
      });

      if ((Array.isArray(imagesToDisplay) && imagesToDisplay.length === 0) || !imagesToDisplay) {
        imagesToDisplay = this.getSingleImageObj(uniqueId);
      }
      return imagesToDisplay;
    }
    return [];
  };

  getCurrentProductsInfo = (currentProduct) =>
    currentProduct && Object.keys(currentProduct).length > 0;

  getPrimaryBrand = (retrievedProductInfo) =>
    retrievedProductInfo && retrievedProductInfo.primaryBrand;

  getIsHardMarkDown = (currentProduct, retrievedProductInfo) =>
    currentProduct?.hardMarkDown || retrievedProductInfo?.hardMarkDown;

  extractBrand = (str) => {
    // Split the string by the '?' character
    const parts = str?.split('?');

    // Find the part that contains the 'brand' key
    const brandPart = parts?.find((part) => part?.includes('brand='));

    if (brandPart) {
      // Split the brand part by the '=' character and return the value after it
      return brandPart?.split('=')[1];
    }

    // Return null if the 'brand' key is not found
    return null;
  };

  dataFormattingKitGroupng = (currentProduct, alternateBrand) => {
    const kitGrouping = currentProduct?.kitGrouping || [];
    const primaryBrand =
      currentProduct?.primaryBrand ||
      alternateBrand ||
      this.extractBrand(currentProduct?.generalProductId);
    const productId = currentProduct?.productId;
    const imageUrl = currentProduct?.imagesByColor?.[productId]?.basicImageUrl?.split('/')[1];
    const checkforCurrentpid = currentProduct?.kitGrouping?.filter(
      (item) => item?.productid === productId
    );
    if ((checkforCurrentpid?.length === 0 || !checkforCurrentpid) && kitGrouping?.length > 0) {
      const currentKit = {
        brand: primaryBrand,
        productid: productId,
        productimage: imageUrl,
        seo_token: currentProduct?.seoToken,
      };
      kitGrouping?.unshift(currentKit);
    }
    return kitGrouping;
  };

  clearAddToBagErrorOnUpdate = () => {
    const {
      clearUnavailableProductIds,
      clearAddToBagError,
      clearMultipleAddToBagError,
      atbUnavailableProducts,
      addToBagError,
      multipleAddToBagError,
    } = this.props;
    if (atbUnavailableProducts?.error) {
      clearUnavailableProductIds();
    }
    if (addToBagError) {
      clearAddToBagError();
    }
    if (multipleAddToBagError?.errMsg) {
      clearMultipleAddToBagError();
    }
  };

  // eslint-disable-next-line sonarjs/cognitive-complexity, complexity
  render() {
    const {
      currentProduct,
      navigation,
      longDescription,
      shortDescription,
      itemPartNumber,
      currency,
      currencyAttributes,
      currentBundle,
      addToBagEcom,
      currentState,
      addToBagError,
      multipleAddToBagError,
      addToBagErrorId,
      isPickupModalOpen,
      addToFavorites,
      isLoggedIn,
      isPlcc,
      AddToFavoriteErrorMsg,
      removeAddToFavoritesErrorMsg,
      breadCrumbs,
      productDetails,
      isKeepAliveEnabled,
      toastMessage,
      isLoading,
      topPromos,
      isOnModelAbTestBundlePdp,
      isInternationalShipping,
      // currencySign,
      isEnabledOutfitAddedCTA,
      showAddedToBagCta,
      getUserFavtList,
      onSetLastDeletedItemIdAction,
      defaultWishListFromState,
      errorMessages,
      setSelectedOutfitProduct,
      addMultipleToBagEcom,
      selectedOutfitProducts,
      alternateBrand,
      route,
      isSyteEnabled,
      trackAnalyticsClick,
      ratingsProductId,
      isDynamicBadgeEnabled,
      isPDPSmoothScrollEnabled,
      isHiddenPDPAltImageEnabled,
      isShowPriceRangeKillSwitch,
      showPriceRangeForABTest,
      isHideOriginalPriceAndMarchantTagEnabled,
      isBundleOutfitInfluencerHandleEnabled,
      isBundlePageRedesign,
      onQuickViewOpenClick,
      isInfluencerPicksEnabled,
      isNewSwatchUrlEnabled,
      currencySymbol,
      promotionsData,
      serverTime,
      isBuyMorePromoEnabled,
      resetSlpLoadingState,
      inYourBagProducts,
      showToastModalAction,
      toastModalState,
      isCombinedKitsEnabled,
      isNewDesignToggleOptionsEnabled,
      defaultView,
      carryForwardImgUrlActn,
      carryForwardImgUrlValue,
      clearBundleDetails,
      isPJPlannerExperienceEnabled,
      departmentBundleProducts,
      favAddRemoveLoadingState,
      addToCollectionList,
      resetDesignYourBagDataAction,
      removeProductFromCollectionAction,
      increaseQuantityInCollectionsAction,
      decreaseQuantityInCollectionsAction,
      isCollectionsZoomEnabled,
      isPinchZoomPDPImageEnabled,
      isUpdatedPromotionsDisplayEnabled,
      atbUnavailableProducts,
      isPJPlannerStickyMiniBagEnabled,
      isSplittingExtendedSizesEnabled,
      isDynamicBadgeEnabledAbtest,
    } = this.props;
    const { retrievedProductInfo, imgConfigVal } = this.state;
    const imagesToDisplay = this.getPlpImages();
    const { router: { asPath: asPathVal } = {} } = this.props;
    const brandName = getBrandNameFromHref(asPathVal);
    const currentProductsInfo = this.getCurrentProductsInfo(currentProduct);
    const productAvailable = currentProductsInfo && currentBundle?.length;
    const productItemsInfo = selectedOutfitProducts.map((productInfo) => {
      const { outfitProduct } = productInfo;
      const { generalProductId } = outfitProduct;
      const formName = `${OUTFIT_LISTING_FORM}-${generalProductId}`;
      const formValues = getAddedToBagFormValues(currentState, formName);
      return { ...productInfo, quantity: formValues.quantity };
    });
    const getPriceRange = isShowPriceRangeKillSwitch
      ? parseBoolean(isShowPriceRangeKillSwitch)
      : false;
    const fromPLPPage = this.checkIfFromPLPorSLP();
    const multiErrorMessage = multipleAddToBagError && multipleAddToBagError.errMsg;
    const isHardMarkDown = this.getIsHardMarkDown(currentProduct, retrievedProductInfo);
    const isHideOriginalPrice = hideProductOriginalPrice(
      isHardMarkDown,
      isHideOriginalPriceAndMarchantTagEnabled
    );

    if (currentProduct && !productAvailable && !isLoading) {
      return <EmptyPDP />;
    }

    if (isBundlePageRedesign) {
      return (
        <BundleProductNewDesign
          currentProduct={currentProduct}
          selectedColorProductId={this.selectedColorProductId}
          route={route}
          shortDescription={shortDescription}
          itemPartNumber={itemPartNumber}
          longDescription={longDescription}
          currencySymbol={currencySymbol}
          currencyAttributes={currencyAttributes}
          breadCrumbs={breadCrumbs}
          productDetails={productDetails}
          topPromos={topPromos}
          isOnModelAbTestBundlePdp={isOnModelAbTestBundlePdp}
          isOutfitPage={false}
          isFromBundlePage={true}
          errorMessages={errorMessages}
          alternateBrand={brandName || alternateBrand}
          fromPLPPage={fromPLPPage}
          plpImagesToDisplay={imagesToDisplay}
          isBundleOutfitInfluencerHandleEnabled={isBundleOutfitInfluencerHandleEnabled}
          isBundlePageRedesign={isBundlePageRedesign}
          onQuickViewOpenClick={onQuickViewOpenClick}
          isInfluencerPicksEnabled={isInfluencerPicksEnabled}
          isHideOriginalPrice={isHideOriginalPrice}
          currentBundle={currentBundle}
          isHideOriginalPriceAndMarchantTagEnabled={isHideOriginalPriceAndMarchantTagEnabled}
          isNewSwatchUrlEnabled={isNewSwatchUrlEnabled}
          promotionsData={promotionsData}
          isUpdatedPromotionsDisplayEnabled={isUpdatedPromotionsDisplayEnabled}
          serverTime={serverTime}
          isBuyMorePromoEnabled={isBuyMorePromoEnabled}
          isDynamicBadgeEnabled={isDynamicBadgeEnabled}
          resetSlpLoadingState={resetSlpLoadingState}
          inYourBagProducts={inYourBagProducts}
          retrievedProductInfo={retrievedProductInfo}
          currency={currency}
          isShowPriceRangeKillSwitch={getPriceRange}
          showPriceRangeForABTest={showPriceRangeForABTest}
          primaryBrand={this.getPrimaryBrand(retrievedProductInfo)}
          isKeepAliveEnabled={isKeepAliveEnabled}
          isCombinedKitsEnabled={isCombinedKitsEnabled}
          isNewDesignToggleOptionsEnabled={isNewDesignToggleOptionsEnabled}
          defaultView={defaultView}
          carryForwardImgUrlActn={carryForwardImgUrlActn}
          carryForwardImgUrlValue={carryForwardImgUrlValue}
          kitGrouping={this.dataFormattingKitGroupng(currentProduct, alternateBrand)}
          handleAddToBag={this.handleAddToBag}
          addToFavorites={addToFavorites}
          addToBagEcom={addToBagEcom}
          currentState={currentState}
          isLoggedIn={isLoggedIn}
          addToBagErrorId={addToBagErrorId}
          addToBagError={addToBagError}
          AddToFavoriteErrorMsg={AddToFavoriteErrorMsg}
          removeAddToFavoritesErrorMsg={removeAddToFavoritesErrorMsg}
          onSetLastDeletedItemIdAction={onSetLastDeletedItemIdAction}
          wishList={defaultWishListFromState}
          isInternationalShipping={isInternationalShipping}
          isEnabledOutfitAddedCTA={isEnabledOutfitAddedCTA}
          showAddedToBagCta={showAddedToBagCta}
          showToastModalAction={showToastModalAction}
          toastModalState={toastModalState}
          clearBundleDetails={clearBundleDetails}
          productAvailable={productAvailable}
          isLoading={isLoading}
          isPJPlannerExperienceEnabled={isPJPlannerExperienceEnabled}
          departmentBundleProducts={departmentBundleProducts}
          favAddRemoveLoadingState={favAddRemoveLoadingState}
          handlePJPlannerMultiItemAddToBag={this.handlePJPlannerMultiItemAddToBag}
          addToCollectionList={addToCollectionList}
          resetDesignYourBagDataAction={resetDesignYourBagDataAction}
          removeProductFromCollectionAction={removeProductFromCollectionAction}
          increaseQuantityInCollectionsAction={increaseQuantityInCollectionsAction}
          decreaseQuantityInCollectionsAction={decreaseQuantityInCollectionsAction}
          isCollectionsZoomEnabled={isCollectionsZoomEnabled}
          isPinchZoomPDPImageEnabled={isPinchZoomPDPImageEnabled}
          atbUnavailableProducts={atbUnavailableProducts}
          multipleAddToBagError={multiErrorMessage}
          clearAddToBagErrorOnUpdate={this.clearAddToBagErrorOnUpdate}
          isPJPlannerStickyMiniBagEnabled={isPJPlannerStickyMiniBagEnabled}
          isSplittingExtendedSizesEnabled={isSplittingExtendedSizesEnabled}
          isDynamicBadgeEnabledAbtest={isDynamicBadgeEnabledAbtest}
        />
      );
    }

    return (
      <>
        {productAvailable ? (
          <BundleProduct
            currentProduct={currentProduct}
            selectedColorProductId={this.selectedColorProductId}
            navigation={navigation}
            route={route}
            shortDescription={shortDescription}
            itemPartNumber={itemPartNumber}
            longDescription={longDescription}
            currency={currency}
            currencyAttributes={currencyAttributes}
            currentBundle={currentBundle}
            handleAddToBag={this.handleAddToBag}
            addToBagEcom={addToBagEcom}
            currentState={currentState}
            addToBagError={addToBagError}
            addToBagErrorId={addToBagErrorId}
            multipleAddToBagError={multiErrorMessage}
            isPickupModalOpen={isPickupModalOpen}
            addToFavorites={addToFavorites}
            isLoggedIn={isLoggedIn}
            isPlcc={isPlcc}
            AddToFavoriteErrorMsg={AddToFavoriteErrorMsg}
            removeAddToFavoritesErrorMsg={removeAddToFavoritesErrorMsg}
            breadCrumbs={breadCrumbs}
            productDetails={productDetails}
            isKeepAliveEnabled={isKeepAliveEnabled}
            toastMessage={toastMessage}
            topPromos={topPromos}
            isMatchingFamily // TODO: Need to add kill switch for this
            isOnModelAbTestBundlePdp={isOnModelAbTestBundlePdp}
            isInternationalShipping={isInternationalShipping}
            isEnabledOutfitAddedCTA={isEnabledOutfitAddedCTA}
            showAddedToBagCta={showAddedToBagCta}
            getUserFavtList={getUserFavtList}
            onSetLastDeletedItemIdAction={onSetLastDeletedItemIdAction}
            wishList={defaultWishListFromState}
            defaultWishListFromState={defaultWishListFromState}
            isOutfitPage={false}
            isFromBundlePage={true}
            errorMessages={errorMessages}
            alternateBrand={brandName || alternateBrand}
            setSelectedOutfitProduct={setSelectedOutfitProduct}
            selectedOutfitProducts={productItemsInfo}
            handleMultipleAddToBag={this.handleMultipleAddToBag}
            addMultipleToBagEcom={addMultipleToBagEcom}
            isNewReDesignEnabled={true}
            fromPLPPage={fromPLPPage}
            isSyteEnabled={isSyteEnabled}
            trackAnalyticsClick={trackAnalyticsClick}
            plpImagesToDisplay={imagesToDisplay}
            isHideOriginalPrice={isHideOriginalPrice}
            isHideOriginalPriceAndMarchantTagEnabled={isHideOriginalPriceAndMarchantTagEnabled}
            isBundleOutfitInfluencerHandleEnabled={isBundleOutfitInfluencerHandleEnabled}
            showToastModalAction={showToastModalAction}
            toastModalState={toastModalState}
            isSplittingExtendedSizesEnabled={isSplittingExtendedSizesEnabled}
          />
        ) : null}
        {isLoading && !productAvailable ? (
          <BundleProductItemsSkeleton
            alternateBrand={brandName || alternateBrand}
            currentProduct={currentProduct}
            fromPLPPage={fromPLPPage}
            retrievedProductInfo={retrievedProductInfo}
            primaryBrand={retrievedProductInfo && retrievedProductInfo.primaryBrand}
            ratingsProductId={ratingsProductId}
            imgConfigVal={imgConfigVal}
            isDynamicBadgeEnabled={isDynamicBadgeEnabled}
            isPDPSmoothScrollEnabled={isPDPSmoothScrollEnabled}
            isHiddenPDPAltImageEnabled={isHiddenPDPAltImageEnabled}
            isKeepAliveEnabled={isKeepAliveEnabled}
            currency={currency}
            currencyAttributes={currencyAttributes}
            isShowPriceRangeKillSwitch={getPriceRange}
            showPriceRangeForABTest={showPriceRangeForABTest}
            isHideOriginalPrice={isHideOriginalPrice}
            isDynamicBadgeEnabledAbtest={isDynamicBadgeEnabledAbtest}
          />
        ) : null}
      </>
    );
  }
}

ProductBundleContainer.pageInfo = {
  pageId: 'b',
};

ProductBundleContainer.getInitActions = () => initActions;

function mapStateToProps(state, ownProps) {
  const { query = '' } = ownProps?.router || {};
  return {
    currentProduct: getCurrentProduct(state),
    isLoading: getLoadingState(state),
    productDetails: prodDetails(state),
    shortDescription: getShortDescription(state),
    longDescription: getDescription(state),
    itemPartNumber: getGeneralProductId(state),
    currency: getCurrentCurrency(state),
    currencyAttributes: getCurrencyAttributes(state),
    alternateSizes: getAlternateSizes(state),
    currentBundle: getCurrentBundle(state),
    currentState: state,
    addToBagError: getAddedToBagError(state),
    multipleAddToBagError: getMultipleItemsAddedToBagError(state),
    addToBagErrorId: getAddedToBagErrorCatId(state),
    isPickupModalOpen: getIsPickupModalOpen(state),
    isLoggedIn: getUserLoggedInState(state) && !isRememberedUser(state),
    isPlcc: isPlccUser(state),
    AddToFavoriteErrorMsg: fetchAddToFavoriteErrorMsg(state),
    breadCrumbs: getBreadCrumbs(state, query),
    isKeepAliveEnabled: getIsKeepAliveProduct(state),
    topPromos: getPDPTopPromos(state),
    isOnModelAbTestBundlePdp: getOnModelImageAbTestBundlePdp(state),
    isInternationalShipping: getIsInternationalShipping(state),
    // currencySign: BAGPAGE_SELECTORS.getCurrentCurrency(state),
    pageUrl: getPageUrl(state),
    isEnabledOutfitAddedCTA: !isCanada() && getIsOutfitAddedCTAEnabled(state),
    showAddedToBagCta: getShowAddedToBagCTA(state),
    defaultWishListFromState: wishListFromState(state),
    errorMessages: fetchErrorMessages(state),
    selectedOutfitProducts: getSelectedProductList(state),
    alternateBrand: getAlternateBrandName(state),
    isNewReDesign: getIsNewReDesignEnabled(state),
    isSyteEnabled: getIsSyteEnabled(state),
    plpProductData: getPlpProductData(state) || {},
    slpProductData: getSlpProductData(state) || {},
    ratingsProductId: getRatingsProductId(state),
    isDynamicBadgeEnabled: getIsDynamicBadgeEnabled(state),
    isPDPSmoothScrollEnabled: getIsPDPSmoothScrollEnabled(state),
    isHiddenPDPAltImageEnabled: getIsHiddenPDPAltImageEnabled(state),
    isShowPriceRangeKillSwitch: getIsShowPriceRange(state),
    showPriceRangeForABTest: getABTestIsShowPriceRange(state),
    slpData: getSlpData(state),
    isPDPInventoryCheckEnabled: getIsPDPInventoryCheckEnabled(state),
    isHideOriginalPriceAndMarchantTagEnabled: getIsHideOriginalPriceAndMarchantTagEnabled(state),
    isBundleOutfitInfluencerHandleEnabled: getBundleOutfitInfluencerHandleAbTest(state),
    isBundlePageRedesign: getBundlePageRedesign(state),
    isBundleNewDesignEnabled: getIsBundleNewDesignEnabled(state),
    isCombinedKitEnabled: getIsCombinedKitEnabled(state),
    isInfluencerPicksEnabled: getInfluencerPicksEnabled(state),
    isNewSwatchUrlEnabled: getIsNewSwatchURLEnabled(state),
    currencySymbol: getCurrentCurrencySymbol(state),
    promotionsData: getPromotionsData(state),
    serverTime: getServerTimeFromState(state),
    isBuyMorePromoEnabled: getIsBuyMorePromoEnabled(state),
    inYourBagProducts: getInYourBagProducts(state),
    toastModalState: getToastModalState(state),
    quickViewProductId: getUniqueId(state),
    isQVModalOpen: getModalState(state),
    isOnModelAbTestOutfitPdp: getOnModelImageAbTestOutfitPdp(state),
    isCombinedKitsEnabled: getCombinedKits(state),
    isNewDesignToggleOptionsEnabled: getIsNewDesignToggleOptionsEnabled(state),
    defaultView: getDefaultView(state),
    carryForwardImgUrlValue: getCarryForwardImgUrl(state),
    isPJPlannerExperienceEnabled: getIsPJPlannerExperienceEnabled(state),
    departmentBundleProducts: getDepartmentBundleProducts(state) || {},
    favAddRemoveLoadingState: getDefaultFavItemInProgressFlag(state),
    addToCollectionList: getAddToCollectionList(state),
    isCollectionsZoomEnabled: getIsCollectionsZoomEnabled(state),
    isPinchZoomPDPImageEnabled: getIsPinchZoomPDPImageEnabled(state),
    plccOfferPercentage: getPLCCDiscountValue(state) || getPlccOfferPercentage(state),
    isUpdatedPromotionsDisplayEnabled: getIsUpdatedPromotionsDisplayEnabled(state),
    atbUnavailableProducts: getATBUnavailableProducts(state),
    isPJPlannerStickyMiniBagEnabled: getIsPJPlannerStickyMiniBagEnabled(state),
    User: getUserState(state),
    APIConfig: getAPIConfigForAdobe(state),
    session: getSessionDataForAdobe(state),
    isSLPNewTileImplementationEnabled: getIsSLPNewTileImplementationEnabled(state),
    isSplittingExtendedSizesEnabled: getIsSplittingExtendedSizesEnabled(state),
    isDynamicBadgeEnabledAbtest: getIsDisableDynamicBadgeFlagAbtest(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getDetails: (payload) => {
      dispatch(getProductDetails(payload));
    },
    addToBagEcom: (payload) => {
      dispatch(addToCartEcom(payload));
    },
    addToBagEcomNew: (payload) => {
      dispatch(addToCartEcomNewDesign(payload));
    },
    clearAddToBagError: () => {
      dispatch(clearAddToBagErrorState());
    },
    clearMultipleAddToBagError: () => {
      dispatch(clearAddToCartMultipleItemErrorState());
    },
    clearBundleDetails: () => {
      dispatch(clearBundleState());
    },
    addToFavorites: (payload) => {
      dispatch(addItemsToWishlist(payload));
    },
    removeAddToFavoritesErrorMsg: (payload) => {
      dispatch(removeAddToFavoriteErrorState(payload));
    },
    toastMessage: (payload) => {
      dispatch(toastMessageInfo(payload));
    },
    getUserFavtList: (payload) => {
      dispatch(getUserFavt(payload));
    },
    onSetLastDeletedItemIdAction: (payload) => {
      dispatch(setLastDeletedItemIdAction(payload));
    },
    setSelectedOutfitProduct: (payload) => {
      dispatch(setSelectedOutfitProductList(payload));
    },
    resetOutFitProductState: () => {
      dispatch(resetOutfitDetails());
    },
    clearOutFitProductState: () => {
      dispatch(clearOutfitDetails());
    },
    getOutfit: (payload) => {
      dispatch(getOutfitDetails(payload));
    },
    addMultipleToBagEcom: (payload) => {
      dispatch(addMultipleItemsToCartEcom(payload));
    },
    addMultipleToBagEcomNew: (payload) => {
      dispatch(addMultipleItemsToCartEcomNew(payload));
    },
    addToBagPayloadTotalCountAction: (payload) => {
      dispatch(addToBagPayloadTotalCount(payload));
    },
    trackAnalyticsClick: (payload, eventData) => {
      dispatch(setClickAnalyticsData(eventData));
      const timer = setTimeout(() => {
        dispatch(trackClick(payload));
        clearTimeout(timer);
      }, 100);
    },

    onQuickViewOpenClick: (payload) => {
      const { image, productInfo } = payload;
      dispatch(setQuickViewProductImage(image));
      dispatch(setItemDataForQuickView(productInfo));
      dispatch(openQuickViewWithValues(payload));
    },

    resetSlpLoadingState: (payload) => {
      dispatch(setSlpLoadingState(payload));
    },
    getInYourBagData: (payload) => {
      dispatch(getInYourBagProductCount(payload));
    },
    setIsBundlePage: (payload) => {
      dispatch(setIsBundle(payload));
    },
    showToastModalAction: (payload) => {
      dispatch(showToastModal(payload));
    },
    openApplyNowModal: (payload) => {
      dispatch(toggleApplyNowModal(payload));
    },
    carryForwardImgUrlActn: (payload) => {
      dispatch(carryForwardImgUrl(payload));
    },
    resetDesignYourBagDataAction: () => {
      dispatch(resetDesignYourBagData());
    },
    removeProductFromCollectionAction: (payload) => {
      dispatch(removeProductFromCollections(payload));
    },
    increaseQuantityInCollectionsAction: (payload) => {
      dispatch(increaseQuantityInCollections(payload));
    },
    decreaseQuantityInCollectionsAction: (payload) => {
      dispatch(decreaseQuantityInCollections(payload));
    },
    clearUnavailableProductIds: () => {
      dispatch(setUnavailableProductIds(null));
    },
  };
}

ProductBundleContainer.propTypes = {
  getDetails: PropTypes.func.isRequired,
  navigation: PropTypes.shape({}).isRequired,
  currentProduct: PropTypes.shape({}),
  currentBundle: PropTypes.arrayOf(PropTypes.shape({})),
  shortDescription: PropTypes.string,
  itemPartNumber: PropTypes.string,
  longDescription: PropTypes.string,
  currency: PropTypes.string,
  currencyAttributes: PropTypes.shape({}),
  addToBagEcom: PropTypes.func,
  setSelectedOutfitProduct: PropTypes.func,
  addMultipleToBagEcom: PropTypes.func,
  resetOutFitProductState: PropTypes.func,
  clearOutFitProductState: PropTypes.func,
  clearBundleDetails: PropTypes.func,
  currentState: PropTypes.shape({}),
  multipleAddToBagError: PropTypes.string,
  addToBagError: PropTypes.string,
  addToBagErrorId: PropTypes.string,
  isPickupModalOpen: PropTypes.bool,
  addToFavorites: PropTypes.func,
  isLoggedIn: PropTypes.bool,
  isPlcc: PropTypes.bool,
  router: PropTypes.shape({}).isRequired,
  AddToFavoriteErrorMsg: PropTypes.string,
  removeAddToFavoritesErrorMsg: PropTypes.func,
  breadCrumbs: PropTypes.shape({}),
  productDetails: PropTypes.arrayOf(PropTypes.shape({})),
  formValues: PropTypes.shape({}).isRequired,
  isKeepAliveEnabled: PropTypes.bool,
  toastMessage: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  topPromos: PropTypes.shape({}),
  isOnModelAbTestBundlePdp: PropTypes.bool,
  isInternationalShipping: PropTypes.bool.isRequired,
  // currencySign: PropTypes.string,
  pageUrl: PropTypes.string.isRequired,
  isEnabledOutfitAddedCTA: PropTypes.bool,
  showAddedToBagCta: PropTypes.string,
  onSetLastDeletedItemIdAction: PropTypes.func,
  getUserFavtList: PropTypes.func,
  defaultWishListFromState: PropTypes.shape({}),
  errorMessages: PropTypes.shape({}),
  selectedOutfitProducts: PropTypes.shape({}),
  isNewReDesign: PropTypes.bool,
  isPDPInventoryCheckEnabled: PropTypes.bool,
  isHideOriginalPriceAndMarchantTagEnabled: PropTypes.bool,
  isBundleOutfitInfluencerHandleEnabled: PropTypes.bool,
  isBundlePageRedesign: PropTypes.bool,
  isBundleNewDesignEnabled: PropTypes.bool,
  onQuickViewOpenClick: PropTypes.func,
  isInfluencerPicksEnabled: PropTypes.bool,
  isNewSwatchUrlEnabled: PropTypes.bool,
  currencySymbol: PropTypes.string,
  promotionsData: PropTypes.shape({}),
  serverTime: PropTypes.number,
  isBuyMorePromoEnabled: PropTypes.bool,
  resetSlpLoadingState: PropTypes.func,
  toastModalState: PropTypes.shape({
    duration: PropTypes.number,
    showToast: PropTypes.bool,
  }),
  showToastModalAction: PropTypes.func,
  isNewDesignToggleOptionsEnabled: PropTypes.bool,
  defaultView: PropTypes.string,
  carryForwardImgUrlActn: PropTypes.func,
  carryForwardImgUrlValue: PropTypes.string,
  isPJPlannerExperienceEnabled: PropTypes.bool,
  departmentBundleProducts: PropTypes.shape({}),
  isCollectionsZoomEnabled: PropTypes.bool,
  isPinchZoomPDPImageEnabled: PropTypes.bool,
  isUpdatedPromotionsDisplayEnabled: PropTypes.bool,
  increaseQuantityInCollectionsAction: PropTypes.func,
  decreaseQuantityInCollectionsAction: PropTypes.func,
  atbUnavailableProducts: PropTypes.shape({}),
  clearUnavailableProductIds: PropTypes.func,
  User: PropTypes.shape({}),
  APIConfig: PropTypes.shape({}),
  session: PropTypes.shape({}),
  isSLPNewTileImplementationEnabled: PropTypes.bool,
};

ProductBundleContainer.defaultProps = {
  currentProduct: {},
  currentBundle: [{}, {}],
  shortDescription: '',
  itemPartNumber: '',
  longDescription: '',
  currency: 'USD',
  currencyAttributes: {
    exchangevalue: 1,
  },
  addToBagEcom: () => {},
  setSelectedOutfitProduct: () => {},
  resetOutFitProductState: () => {},
  clearOutFitProductState: () => {},
  clearBundleDetails: () => {},
  addMultipleToBagEcom: () => {},
  currentState: {},
  multipleAddToBagError: '',
  addToBagError: '',
  addToBagErrorId: '',
  isPickupModalOpen: false,
  addToFavorites: () => {},
  isLoggedIn: false,
  isPlcc: false,
  AddToFavoriteErrorMsg: '',
  removeAddToFavoritesErrorMsg: () => {},
  breadCrumbs: [],
  productDetails: [],
  isKeepAliveEnabled: false,
  isLoading: false,
  topPromos: null,
  isOnModelAbTestBundlePdp: false,
  // currencySign: '',
  isEnabledOutfitAddedCTA: false,
  showAddedToBagCta: '',
  onSetLastDeletedItemIdAction: () => {},
  getUserFavtList: () => {},
  defaultWishListFromState: {},
  errorMessages: {},
  selectedOutfitProducts: [],
  isNewReDesign: false,
  isPDPInventoryCheckEnabled: false,
  isHideOriginalPriceAndMarchantTagEnabled: false,
  isBundleOutfitInfluencerHandleEnabled: false,
  isBundlePageRedesign: false,
  isBundleNewDesignEnabled: false,
  onQuickViewOpenClick: () => {},
  isInfluencerPicksEnabled: false,
  isNewSwatchUrlEnabled: false,
  currencySymbol: '$',
  promotionsData: {},
  serverTime: null,
  isBuyMorePromoEnabled: false,
  resetSlpLoadingState: () => {},
  toastModalState: {
    duration: 0,
    showToast: false,
  },
  showToastModalAction: () => {},
  isNewDesignToggleOptionsEnabled: false,
  defaultView: '',
  carryForwardImgUrlActn: () => {},
  carryForwardImgUrlValue: '',
  isPJPlannerExperienceEnabled: false,
  departmentBundleProducts: {},
  isCollectionsZoomEnabled: false,
  isPinchZoomPDPImageEnabled: false,
  isUpdatedPromotionsDisplayEnabled: false,
  increaseQuantityInCollectionsAction: () => {},
  decreaseQuantityInCollectionsAction: () => {},
  atbUnavailableProducts: {},
  clearUnavailableProductIds: () => {},
  User: {},
  APIConfig: {},
  session: {},
  isSLPNewTileImplementationEnabled: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductBundleContainer);
